export default __webpack_public_path__ + "refine-on-phone-53dfb3cbc6aae8216b9f63bea1935444.digested.webp";